let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dA6mO")).then(() => parcelRequire('9fdve'));